import { render, staticRenderFns } from "./TaskView.vue?vue&type=template&id=21390161&scoped=true"
import script from "./TaskView.vue?vue&type=script&lang=js"
export * from "./TaskView.vue?vue&type=script&lang=js"
import style0 from "./TaskView.vue?vue&type=style&index=0&id=21390161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21390161",
  null
  
)

export default component.exports